import { MasterCardIcon } from '@/components/icons/MasterCardIcon';
import { VerveIcon } from '@/components/icons/VerveIcon';
import { VisaIcon } from '@/components/icons/VisaIcon';
import { CreditCardOutlined } from '@ant-design/icons';

// Get card icon component
export const getCardIcon = (type) => {
  switch (type) {
    case 'VISA':
      return <VisaIcon style={{ width: 60, height: 40 }} />;
    case 'MASTERCARD':
      return <MasterCardIcon style={{ width: 60, height: 40 }} />;
    case 'VERVE':
      return <VerveIcon style={{ width: 60, height: 40 }} />;
    default:
      return <CreditCardOutlined style={{ fontSize: 24 }} />;
  }
};
